module.exports = __webpack_public_path__ + "static/media/SalaryUnpaid.30274d8a.svg";